import Dialog from '../../../ui/modal/Dialog';
import Tip from '../../../ui/Tip';
import DeleteSectionTip from '../../../assets/help/delete-section.png';
import React from 'react';
import {handleError, handleSuccess} from '../../../utils/Apollo';
import {ElementType} from '../types';
import {useMutation} from '@apollo/client';
import gql from 'graphql-tag';

type DeleteSectionDlgProps = {
  id: string
  name: React.ReactNode
  show: boolean
  setShowDialog: (close: boolean) => void
  onDelete: (type: ElementType, id: string) => void
}

export default function DeleteSectionDlg({id, name, show, setShowDialog, onDelete}: DeleteSectionDlgProps) {
  const [deleteElement] = useMutation(deleteMutation);

  const deleteSection = () => {
    deleteElement({
      variables: {id},
    }).then(() => {
      handleSuccess('Section deleted');
      setShowDialog(false);
      onDelete(ElementType.Section, id);
    }, (apolloError) => handleError(apolloError));
  };

  return (
    <Dialog show={show} actionBtnTitle="Delete" onClose={() => setShowDialog(false)}
      title="Delete section" onConfirm={() => deleteSection()} closeBtnTitle="Cancel">
      <p>
        You are going to delete <b>{name}</b> section from the system. The section
        will be deleted from all evaluation
        form configurations, running and future events. You cannot revert this action.
      </p>
      <Tip className="mt-3">
        <div className="flex flex-col">
            <span>
              <b className="-mt-px">Tip:</b>&nbsp;if you want to remove the section only from the current form configuration,
                                                click Trash icon in the upper
                                                right corner of the section block
            </span>
          <span className="inline-block relative mt-3 mb-1">
              <img className="rounded-md" src={DeleteSectionTip} alt="Delete Section"/>
            </span>
        </div>
      </Tip>
    </Dialog>
  )
}

const deleteMutation = gql`
  mutation DeleteMutation($id: ID!)
  {
    section: deleteSection(id: $id) {
      id
    }
  }
`;
